module.exports = "../images/icons/iscritti.svg";